/**
 * @generated SignedSource<<03db2121056c991635b7a0d8ae9be309>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useSideNavToggleStateQuery$data = {
  readonly navPlatSidebarData?: {
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly key: string | null;
        readonly value: string | null;
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentType": "useSideNavToggleStateQuery";
};
export type useSideNavToggleStateQuery$key = {
  readonly " $data"?: useSideNavToggleStateQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSideNavToggleStateQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "navPlatSidebarDataEntityAri"
    },
    {
      "kind": "RootArgument",
      "name": "ownerAri"
    },
    {
      "kind": "RootArgument",
      "name": "skipNavPlatSidebarData"
    }
  ],
  "kind": "Fragment",
  "name": "useSideNavToggleStateQuery",
  "selections": [
    {
      "condition": "skipNavPlatSidebarData",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "alias": "navPlatSidebarData",
          "args": [
            {
              "kind": "Variable",
              "name": "entityAri",
              "variableName": "navPlatSidebarDataEntityAri"
            },
            {
              "kind": "Variable",
              "name": "ownerAri",
              "variableName": "ownerAri"
            }
          ],
          "concreteType": "SettingsNavigationCustomisation",
          "kind": "LinkedField",
          "name": "settings_navigationCustomisation",
          "plural": false,
          "selections": [
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 100
                }
              ],
              "concreteType": "SettingsDisplayPropertyConnection",
              "kind": "LinkedField",
              "name": "properties",
              "plural": false,
              "selections": [
                {
                  "concreteType": "SettingsDisplayProperty",
                  "kind": "LinkedField",
                  "name": "nodes",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "key"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "value"
                    }
                  ]
                }
              ],
              "storageKey": "properties(first:100)"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "b3cf5c0f07c9195d88b669babfa4f5fb";

export default node;
